import ElementUI from 'element-ui';
import Cookies from 'js-cookie'
import Vue from 'vue';
import Vuex from 'vuex';
import Router from 'vue-router';
import firebaseInit from '@/shared/firebase/firebase-init';
import '@/styles/main.scss';
import '@/styles/font-awesome.less';
import App from './app';
import appModule from './app-module';
import i18n from './lang' // Internationalization
import './icons' // icon

Vue.use(Router);
Vue.config.productionTip =
  process.env.NODE_ENV === 'production';
// Vue.use(ElementUI);
Vue.use(Vuex);
appModule.setupComponentsFiltersDirectivesAndMixins();
firebaseInit();

Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})
// eslint-disable-next-line
new Vue({
  el: '#app',
  store: appModule.storeAsync(),
  router: appModule.routerAsync(),
  i18n,
  template: '<app/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js